(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msh-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function toggle(button, panel) {
      var isOpen = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!isOpen));
      if (isOpen) {
        panel.setAttribute('hidden', '');
      } else {
        panel.removeAttribute('hidden');
      }
    }

    function initMshFaq(root) {
      root.querySelectorAll('.msh-faq__cat-toggle').forEach(function (button) {
        var panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel) return;
        button.addEventListener('click', function () {
          toggle(button, panel);
        });
      });
      root.querySelectorAll('.msh-faq__qa-toggle').forEach(function (button) {
        var panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel) return;
        button.addEventListener('click', function () {
          toggle(button, panel);
        });
      });
    }

    function initAll() {
      document.querySelectorAll('.msh-faq').forEach(initMshFaq);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msh-featured-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initMshFeatured(root) {
      var grid = root.querySelector('.msh-featured__grid');
      var setMid = root.querySelector('.msh-featured__set--mid');
      var prev = root.querySelector('.msh-featured__nav--prev');
      var next = root.querySelector('.msh-featured__nav--next');
      if (!grid || !setMid || !prev || !next) return;

      // Measured once at init: all three duplicated sets are identical width,
      // so this value is stable and only used for the initial scroll position
      // and the wrap-around boundary check.
      var setWidth = setMid.getBoundingClientRect().width + 20; // + gap between sets

      grid.scrollLeft = setWidth; // start on the middle (real) set, room to go either way

      // Measured fresh on every click, never cached: caching this at load time
      // previously caused a bug where layout hadn't settled yet, producing a
      // near-zero card width and near-zero movement per click.
      function getCardPitch() {
        return setMid.querySelector('.msh-fcard').getBoundingClientRect().width + 16;
      }

      var animating = false;
      function animateBy(delta) {
        if (animating) return;
        animating = true;
        var start = grid.scrollLeft;
        var target = start + delta;
        var duration = 380;
        var startTime = null;
        function easeOutCubic(t) {
          return 1 - Math.pow(1 - t, 3);
        }
        function step(timestamp) {
          if (startTime === null) startTime = timestamp;
          var elapsed = timestamp - startTime;
          var progress = Math.min(elapsed / duration, 1);
          grid.scrollLeft = start + (target - start) * easeOutCubic(progress);
          if (progress < 1) {
            window.requestAnimationFrame(step);
          } else {
            if (grid.scrollLeft >= setWidth * 2) {
              grid.scrollLeft -= setWidth;
            } else if (grid.scrollLeft <= 0) {
              grid.scrollLeft += setWidth;
            }
            animating = false;
          }
        }
        window.requestAnimationFrame(step);
      }

      next.addEventListener('click', function () {
        animateBy(getCardPitch());
      });
      prev.addEventListener('click', function () {
        animateBy(-getCardPitch());
      });
    }

    function initAll() {
      document.querySelectorAll('.msh-featured').forEach(initMshFeatured);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msh-find-my-shoes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initMshFindMyShoes(root) {
      var panels = root.querySelectorAll('[data-msh-fms-panel]');
      var startBtn = root.querySelector('[data-msh-fms-start]');
      var chosenEl = root.querySelector('[data-msh-fms-chosen]');
      var base = root.getAttribute('data-base-collection') || 'all';
      if (!panels.length || !startBtn) return;

      // One entry per step. A skipped step, or an answer with no tag, stays
      // null and simply drops out of the filter.
      var answers = { 1: null, 2: null, 3: null };
      var labels = { 1: null, 2: null, 3: null };

      function show(name) {
        panels.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-msh-fms-panel') === String(name));
        });
      }

      function go(step) {
        if (step < 1) {
          show('intro');
          return;
        }
        if (step > 3) {
          finish();
          return;
        }
        show(step);
      }

      function finish() {
        show('result');

        var tags = [];
        var picked = [];
        [1, 2, 3].forEach(function (step) {
          if (answers[step]) tags.push(answers[step]);
          if (labels[step]) picked.push(labels[step]);
        });

        if (chosenEl) {
          chosenEl.textContent = picked.length ? picked.join(' + ') : 'Everything';
        }

        // Shopify's native multi-tag filter path: /collections/<base>/<a>+<b>.
        // Tags were handleized server-side by Liquid, so they are already safe
        // in a URL path. With no tags at all this degrades to the plain
        // collection, which is still a real destination rather than a dead end.
        var url = '/collections/' + base;
        if (tags.length) {
          url += '/' + tags.join('+');
        }

        // A short beat so the result panel is actually seen; without it a fast
        // connection makes the final click look like it did nothing.
        setTimeout(function () {
          window.location.href = url;
        }, 350);
      }

      startBtn.addEventListener('click', function () {
        answers = { 1: null, 2: null, 3: null };
        labels = { 1: null, 2: null, 3: null };
        go(1);
      });

      root.querySelectorAll('[data-msh-fms-option]').forEach(function (option) {
        option.addEventListener('click', function () {
          var step = parseInt(option.getAttribute('data-step'), 10);
          var tag = option.getAttribute('data-tag');
          var labelEl = option.querySelector('.msh-fms__option-label');
          answers[step] = tag || null;
          labels[step] = labelEl ? labelEl.textContent.trim() : null;
          go(step + 1);
        });
      });

      root.querySelectorAll('[data-msh-fms-skip]').forEach(function (skip) {
        skip.addEventListener('click', function () {
          var step = parseInt(skip.getAttribute('data-step'), 10);
          answers[step] = null;
          labels[step] = null;
          go(step + 1);
        });
      });

      root.querySelectorAll('[data-msh-fms-back]').forEach(function (back) {
        back.addEventListener('click', function () {
          var panel = back.closest('[data-msh-fms-panel]');
          var step = parseInt(panel.getAttribute('data-msh-fms-panel'), 10);
          go(step - 1);
        });
      });
    }

    function initAll() {
      document.querySelectorAll('[data-msh-fms]').forEach(initMshFindMyShoes);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    // The theme editor re-renders a section on every setting change, which
    // would otherwise leave the freshly injected markup without listeners.
    document.addEventListener('shopify:section:load', function (event) {
      if (!event.target || !event.target.querySelectorAll) return;
      event.target.querySelectorAll('[data-msh-fms]').forEach(initMshFindMyShoes);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msh-product-accordion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initMshAccJump(root) {
      var jumpItems = root.querySelectorAll('[data-msh-acc-jump-target]');
      jumpItems.forEach(function (details) {
        var summary = details.querySelector(':scope > summary');
        if (!summary) return;
        summary.addEventListener('click', function (e) {
          var targetId = details.getAttribute('data-msh-acc-jump-target');
          var target = targetId ? document.getElementById(targetId) : null;
          if (!target) return;
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    }

    function initAll() {
      document.querySelectorAll('.msh-acc-list').forEach(initMshAccJump);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msh-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initMshRecentlyViewed(root) {
      var row = root.querySelector('.msh-recently-viewed__row');
      var next = root.querySelector('.msh-recently-viewed__next');
      if (!row || !next) return;

      function updateVisibility() {
        var hasOverflow = row.scrollWidth > row.clientWidth + 4;
        next.classList.toggle('visible', hasOverflow);
      }

      next.addEventListener('click', function () {
        row.scrollBy({ left: 300, behavior: 'smooth' });
      });

      window.addEventListener('resize', updateVisibility);
      window.addEventListener('load', updateVisibility);
      updateVisibility();
    }

    function initAll() {
      document.querySelectorAll('.msh-recently-viewed').forEach(initMshRecentlyViewed);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msh-recommended"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initMshRecommended(root) {
      var row = root.querySelector('.msh-recommended__row');
      var setReal = root.querySelector('.msh-recommended__set--real');
      if (!row || !setReal) return;

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) return;

      var scrollPos = row.scrollLeft; // tracked separately — browsers round scrollLeft
                                       // to whole pixels, so sub-pixel increments read
                                       // back from row.scrollLeft directly get silently
                                       // dropped every frame and nothing ever moves
      var paused = false;

      row.addEventListener('click', function (e) {
        if (e.target.closest('a')) return; // let product links navigate, don't toggle pause
        paused = !paused;
      });

      function roll() {
        if (!setReal.isConnected) return;

        if (paused) {
          scrollPos = row.scrollLeft; // stay in sync if paused mid-frame
        } else {
          // if the visitor manually dragged/swiped the row, resync instead of
          // snapping back to the old trajectory and fighting their gesture
          if (Math.abs(row.scrollLeft - scrollPos) > 2) {
            scrollPos = row.scrollLeft;
          }
          var setWidth = setReal.getBoundingClientRect().width + 26; // + gap between sets
          if (setWidth > 0) {
            scrollPos += 0.333;
            if (scrollPos >= setWidth) {
              scrollPos -= setWidth;
            } else if (scrollPos < 0) {
              scrollPos += setWidth;
            }
            row.scrollLeft = scrollPos;
          }
        }
        window.requestAnimationFrame(roll);
      }
      window.requestAnimationFrame(roll);
    }

    function initAll() {
      document.querySelectorAll('.msh-recommended').forEach(initMshRecommended);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msh-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Ported from sections/msh-top-picks.liquid's ORIGINAL auto-scroll
    // implementation (see that file's git history / this section's own
    // 2026-09-02 comment above) — same technique, applied to review cards
    // instead of product tiles.
    function initMshReviews(root) {
      var row = root.querySelector('.msh-reviews__row');
      var setReal = root.querySelector('.msh-reviews__set--real');
      var progress = root.querySelector('.msh-reviews__progress');
      var progressThumb = root.querySelector('.msh-reviews__progress-thumb');
      if (!row || !setReal) return;

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var scrollPos = row.scrollLeft; // tracked separately — browsers round scrollLeft
                                       // to whole pixels, so sub-pixel increments read
                                       // back from row.scrollLeft directly get silently
                                       // dropped every frame and nothing ever moves
      var paused = false; // true while the customer is dragging the row or the
                           // progress bar

      var THUMB_RATIO = 0.22;

      function updateProgressBar() {
        if (!progressThumb) return;
        var setWidth = setReal.getBoundingClientRect().width + 20;
        if (setWidth <= 0) return;
        var ratio = ((scrollPos % setWidth) + setWidth) % setWidth / setWidth;
        progressThumb.style.width = (THUMB_RATIO * 100) + '%';
        progressThumb.style.left = (ratio * (1 - THUMB_RATIO) * 100) + '%';
      }

      function roll() {
        if (!setReal.isConnected) return;
        var setWidth = setReal.getBoundingClientRect().width + 20; // + gap between sets
        if (!paused && !reduceMotion && setWidth > 0) {
          scrollPos += 0.333;
          if (scrollPos >= setWidth) {
            scrollPos -= setWidth;
          }
          row.scrollLeft = scrollPos;
          updateProgressBar();
        }
        window.requestAnimationFrame(roll);
      }

      function pauseAutoScroll() {
        paused = true;
      }
      function resumeAutoScroll() {
        scrollPos = row.scrollLeft;
        paused = false;
        updateProgressBar();
      }

      row.addEventListener('pointerdown', pauseAutoScroll);
      row.addEventListener('touchstart', pauseAutoScroll, { passive: true });
      window.addEventListener('pointerup', resumeAutoScroll);
      window.addEventListener('touchend', resumeAutoScroll);
      window.addEventListener('touchcancel', resumeAutoScroll);

      if (progress) {
        var dragging = false;

        function moveFromPointer(e) {
          var rect = progress.getBoundingClientRect();
          var x = e.clientX - rect.left;
          var ratio = Math.min(1, Math.max(0, rect.width > 0 ? x / rect.width : 0));
          var setWidth = setReal.getBoundingClientRect().width + 20;
          scrollPos = ratio * setWidth;
          row.scrollLeft = scrollPos;
          updateProgressBar();
        }

        function onPointerDown(e) {
          dragging = true;
          pauseAutoScroll();
          if (progress.setPointerCapture) progress.setPointerCapture(e.pointerId);
          moveFromPointer(e);
        }
        function onPointerMove(e) {
          if (!dragging) return;
          moveFromPointer(e);
        }
        function onPointerUp() {
          if (!dragging) return;
          dragging = false;
          resumeAutoScroll();
        }

        progress.addEventListener('pointerdown', onPointerDown);
        progress.addEventListener('pointermove', onPointerMove);
        progress.addEventListener('pointerup', onPointerUp);
        progress.addEventListener('pointercancel', onPointerUp);

        window.addEventListener('resize', updateProgressBar);
        updateProgressBar();
      }

      window.requestAnimationFrame(roll);
    }

    function initAll() {
      document.querySelectorAll('.msh-reviews').forEach(initMshReviews);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msh-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var rotator = document.getElementById('rotator');
    if (!rotator) return;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    var lastY = window.scrollY;
    var rotation = 0;
    var ticking = false;

    function update() {
      var y = window.scrollY;
      var delta = y - lastY;
      lastY = y;
      rotation += delta * 0.35;
      rotator.style.transform = 'rotate(' + rotation + 'deg)';
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msh-top-picks"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Same pattern as sections/msh-reviews.liquid's initMshReviews — see
    // that file's comments for why setWidth is measured once at init while
    // card pitch is re-measured fresh on every click.
    function initMshTopPicks(root) {
      var row = root.querySelector('.msh-top-picks__row');
      var setMid = root.querySelector('.msh-top-picks__set--mid');
      var prev = root.querySelector('.msh-top-picks__nav--prev');
      var next = root.querySelector('.msh-top-picks__nav--next');
      if (!row || !setMid || !prev || !next) return;

      var setWidth = setMid.getBoundingClientRect().width + 20;

      function getCardPitch() {
        var card = setMid.querySelector('.msh-tp-card');
        return card ? card.getBoundingClientRect().width + 20 : 0;
      }

      row.scrollLeft = setWidth;

      var animating = false;
      function animateBy(delta) {
        if (animating) return;
        animating = true;
        var start = row.scrollLeft;
        var target = start + delta;
        var duration = 380;
        var startTime = null;
        function easeOutCubic(t) {
          return 1 - Math.pow(1 - t, 3);
        }
        function step(timestamp) {
          if (startTime === null) startTime = timestamp;
          var elapsed = timestamp - startTime;
          var progress = Math.min(elapsed / duration, 1);
          row.scrollLeft = start + (target - start) * easeOutCubic(progress);
          if (progress < 1) {
            window.requestAnimationFrame(step);
          } else {
            if (row.scrollLeft >= setWidth * 2) {
              row.scrollLeft -= setWidth;
            } else if (row.scrollLeft <= 0) {
              row.scrollLeft += setWidth;
            }
            animating = false;
          }
        }
        window.requestAnimationFrame(step);
      }

      next.addEventListener('click', function () {
        animateBy(getCardPitch());
      });
      prev.addEventListener('click', function () {
        animateBy(-getCardPitch());
      });
    }

    function initAll() {
      document.querySelectorAll('.msh-top-picks').forEach(initMshTopPicks);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
